// import TomSelect from "tom-select"
import { selectize } from '@selectize/selectize'
import { Fancybox } from '@fancyapps/ui'
import { Carousel } from '@fancyapps/ui'
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";

import { initializeEngagementForm } from './components/customer-engagement-tool';
// MAIN Content Loaded file
window.addEventListener('DOMContentLoaded', function (e) {
  // initializeEngagementForm();

});
// Get Fancybox going.
window.initFancybox = () => {
  Fancybox.bind("[data-fancybox]", {});
};

let video_btn = document.getElementById('video-btn');
if (video_btn) {
  video_btn.addEventListener('click', function (e) {
    e.preventDefault();
    document.getElementById('link-video').click();
  });
}


jQuery('select:not(".unselectized"):not(".epl-sort-listings")')
  .not('.gform-conversational__form-fields select')
  .selectize({
    plugins: [
      "remove_button",
      "restore_on_backspace",
      "clear_button",
      "auto_position"
    ],
    delimiter: ",",
    persist: false,
    create: function (input) {
      return {
        value: input,
        text: input,
      };
    },
  });
let filters_modal = document.getElementById("filters");
if (filters_modal) {

  filters_modal.addEventListener("shown.bs.modal", function () {
    console.log(this);
    var propertyLocation = document.querySelector('#property-search-form #address_search');
    var selectedOption = propertyLocation ? propertyLocation.selectedOptions : [];

    if (selectedOption.length >= 1) {
      this.querySelector('#surroundingSuburbs').disabled = false;
    }
  });
}

document.querySelectorAll('.property-lists a[data-bs-toggle="tab"]').forEach((tabLink) => {
  tabLink.addEventListener('show.bs.tab', function (e) {
    const view = this.getAttribute('data-view');
    const agent = this.getAttribute('data-agent');
    const sortby = this.getAttribute('data-sortby');
    const sort_order = this.getAttribute('data-sort_order');

    const list = this.getAttribute('data-list');
    const tab_view = document.querySelector('.tab-content #' + view);
    const loader_html = '<div class="ratio ratio-16x9"><div class="logo-loader"></div></div>';

    tab_view.innerHTML = loader_html;

    fetch(docs_ajax.url + '?' + new URLSearchParams({
      'action': "featured_properties",
      'view': view,
      'agent': agent,
      'sortby': sortby,
      'sort_order': sort_order,
      'list': list,
    }))
      .then(response => response.text())
      .then(data => {
        tab_view.innerHTML = data;
      })
      .catch(error => {
        console.error(error);
      });
  });
});

let readMoreButtons = document.querySelectorAll('#descriptionReadMore');
if (readMoreButtons) {

  readMoreButtons.forEach(button => {
    button.addEventListener('click', function () {
      const content = this.closest('.card-body'); // Selects the card-body within the same card
      content.classList.toggle('expanded');

      // Update button text
      this.textContent = content.classList.contains('expanded') ? 'Show less' : 'Read more';
    });
  });

}


const agentCarousel = document.getElementById("agent-carousel");

if (agentCarousel) {
  const options = {
    infinite: true,
    Dots: false,
    Navigation: true,
    adaptiveHeight: true,
    fill: true,
    slidesPerPage: 3,
    Autoplay: {
      timeout: 3000,
      playOnInit: true,
      pauseOnHover: false,
      showProgress: false,
    },
  };


  const AgentCarousel = new Carousel(agentCarousel, options, {
    Autoplay,
  });
}


const rcReviews = document.querySelector(".rcreviews--section .rcreviews--row");

if (rcReviews) {
  const options = {
    infinite: false,
    Dots: false,
    Navigation: true,
    adaptiveHeight: true,
    fill: true,
    slidesPerPage: 3,
  };

  const RCReviews = new Carousel(rcReviews, options);
}


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.open-form-modal').forEach(button => {
    button.addEventListener('click', function () {
      const modalId = this.getAttribute('data-modal-id');

      // Show the modal using Fancybox
      Fancybox.show([{ src: '#' + modalId, type: 'inline' }]);
    });
  });
});


jQuery(document).ready(($) => {
  let url = location.href.replace(/\/$/, "");
  if (location.hash) {
    const hash = url.split("#");
    $('#meet-the-team .nav-tabs a[href="#' + hash[1] + '"]').tab("show");
    url = location.href.replace(/\/#/, "#");
    history.replaceState(null, null, url);
  }

  $('a[data-bs-toggle="tab"]').on("click", function () {
    let newUrl;
    const hash = $(this).attr("href");
    if (hash == "#all") {
      newUrl = url.split("#")[0];
    } else {
      newUrl = url.split("#")[0] + hash;
    }
    history.replaceState(null, null, newUrl);
  });
});

//Trigger modal by hash on URL
document.addEventListener("DOMContentLoaded", function () {
  var hash = window.location.hash;
  if (hash) {
    var button = document.querySelector('[href="' + hash + '"]');
    if (button) {
      button.click();
    }
  }
});
